import init from './init';
import modalSection from './sections/modal';
import headerSection from './sections/header';
import landingSection from './sections/landing';
import tilt from './sections/tilt';
import barba from './barba';

init();
barba();
modalSection();
headerSection();
landingSection();
tilt();



// WEBPACK FOOTER //
// ./source/scripts/main.js